export const icon = ``;

const emojis = {};

export default emojis;
